import { render, staticRenderFns } from "./newTaskList .vue?vue&type=template&id=72ec55b6&scoped=true"
import script from "./newTaskList .vue?vue&type=script&lang=js"
export * from "./newTaskList .vue?vue&type=script&lang=js"
import style0 from "./newTaskList .vue?vue&type=style&index=0&id=72ec55b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec55b6",
  null
  
)

export default component.exports